import script from "./SystemBet.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemBet.vue?vue&type=script&setup=true&lang=js"

import "./SystemBet.vue?vue&type=style&index=0&id=6b4b4da6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4b4da6"]])

export default __exports__